// extracted by mini-css-extract-plugin
export default {"primaryText":"styles_primaryText__WSBf5","subText":"styles_subText__H+o8o"};